import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { messageProviderInjectionKey as b, messageApiInjectionKey as h } from "./context.js";
import O from "./MessageEnvironment.js";
import j from "../../_mixins/use-config.js";
import { omit as y } from "../../_utils/vue/omit.js";
import A from "../../_mixins/use-theme.js";
import { createId as k } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/misc/index.js";
import { defineComponent as P, provide as g, h as l, Teleport as x, Fragment as C } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as m, reactive as L } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const S = Object.assign(Object.assign({}, A.props), {
  to: [String, Object],
  duration: {
    type: Number,
    default: 3e3
  },
  keepAliveOnHover: Boolean,
  max: Number,
  placement: {
    type: String,
    default: "top"
  },
  closable: Boolean,
  containerClass: String,
  containerStyle: [String, Object]
}), B = P({
  name: "MessageProvider",
  props: S,
  setup(i) {
    const {
      mergedClsPrefixRef: r
    } = j(i), s = m([]), n = m({}), o = {
      create(e, t) {
        return a(e, Object.assign({
          type: "default"
        }, t));
      },
      info(e, t) {
        return a(e, Object.assign(Object.assign({}, t), {
          type: "info"
        }));
      },
      success(e, t) {
        return a(e, Object.assign(Object.assign({}, t), {
          type: "success"
        }));
      },
      warning(e, t) {
        return a(e, Object.assign(Object.assign({}, t), {
          type: "warning"
        }));
      },
      error(e, t) {
        return a(e, Object.assign(Object.assign({}, t), {
          type: "error"
        }));
      },
      loading(e, t) {
        return a(e, Object.assign(Object.assign({}, t), {
          type: "loading"
        }));
      },
      destroyAll: p
    };
    g(b, {
      props: i,
      mergedClsPrefixRef: r
    }), g(h, o);
    function a(e, t) {
      const d = k(), u = L(Object.assign(Object.assign({}, t), {
        content: e,
        key: d,
        destroy: () => {
          var c;
          (c = n.value[d]) === null || c === void 0 || c.hide();
        }
      })), {
        max: f
      } = i;
      return f && s.value.length >= f && s.value.shift(), s.value.push(u), u;
    }
    function v(e) {
      s.value.splice(s.value.findIndex((t) => t.key === e), 1), delete n.value[e];
    }
    function p() {
      Object.values(n.value).forEach((e) => {
        e.hide();
      });
    }
    return Object.assign({
      mergedClsPrefix: r,
      messageRefs: n,
      messageList: s,
      handleAfterLeave: v
    }, o);
  },
  render() {
    var i, r, s;
    return l(C, null, (r = (i = this.$slots).default) === null || r === void 0 ? void 0 : r.call(i), this.messageList.length ? l(x, {
      to: (s = this.to) !== null && s !== void 0 ? s : "body"
    }, l("div", {
      class: [`${this.mergedClsPrefix}-message-container`, `${this.mergedClsPrefix}-message-container--${this.placement}`, this.containerClass],
      key: "message-container",
      style: this.containerStyle
    }, this.messageList.map((n) => l(O, Object.assign({
      ref: (o) => {
        o && (this.messageRefs[n.key] = o);
      },
      internalKey: n.key,
      onInternalAfterLeave: this.handleAfterLeave
    }, y(n, ["destroy"], void 0), {
      duration: n.duration === void 0 ? this.duration : n.duration,
      keepAliveOnHover: n.keepAliveOnHover === void 0 ? this.keepAliveOnHover : n.keepAliveOnHover,
      closable: n.closable === void 0 ? this.closable : n.closable
    }))))) : null);
  }
});
export {
  B as default,
  S as messageProviderProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/message/src/MessageProvider.js
// module id = 56
// module chunks = 67